module.exports = __webpack_public_path__ + "static/media/editor.e9b9657a.svg";